import React from "react";
import interfaceImg from "../../images/Assets/interface.png";
import graph from "../../images/Assets/graph.png";

export default function Interface() {
  return (
    <div className="md:px-6 xl:px-10 px-28 flex md:flex-col flex-row max-w-7xl mx-auto items-start pt-20 pb-32 gap-8 md:gap-6 lg:gap-8">
      <div className="flex flex-col items-center justify-center w-full">
        <img src={interfaceImg} alt="interfaceImg" />

        <div className="lg:text-[28px] text-[32px] text-center text-[#0E062A] font-gilroySemibold mt-10">
          Provides chat interfaces
        </div>

        <div className="lg:text-[16px] text-[18px] text-center text-[#544D68] font-gilroyRegular mt-3.5">
          Lorem ipsum dolor sit amet consectetur. Pulvinar etiam <br className="lg:hidden flex" /> curabitur
          at tempor. Viverra pharetra lectus massa aliquam <br className="lg:hidden flex" /> elit risus in.
        </div>
      </div>

      <div className="flex flex-col items-center justify-center w-full">
        <img src={graph} alt="graph" />

        <div className="lg:text-[28px] text-[32px] text-[#0E062A] text-center font-gilroySemibold mt-10 leading-[40px]">
          Provides graph chart, multimodal <br className="lg:hidden flex" /> chatting on your data
        </div>

        <div className="lg:text-[16px] text-[18px] text-[#544D68] text-center font-gilroyRegular mt-3.5">
          Lorem ipsum dolor sit amet consectetur. Viverra pharetra <br className="lg:hidden flex" /> lectus
          massa aliquam elit risus in.
        </div>
      </div>
    </div>
  );
}
